<template>
  <b-navbar
    class="header d-print-none app-header"
    :class="{ 'sidebar-collapsed': sidebarCollapsed }"
  >
    <b-nav>
      <b-nav-item class="menu-toggle" @click="toggleCollapse">
        <span class="fs-lg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-list"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
            />
          </svg>
        </span>
      </b-nav-item>

      <div class="logo-container">
        <a href="/">
          <div
            class="logo-image-container"
            :class="{ 'collapsed-state': sidebarCollapsed }"
          >
            <transition name="slide-fade">
              <img
                class="logo-image first"
                v-show="!sidebarCollapsed && !isMobile"
                src="/redstone-logo-full.svg"
              />
            </transition>
            <transition name="slide-fade">
              <img
                class="logo-image collapsed"
                v-show="sidebarCollapsed || isMobile"
                src="/redstone-hex.svg"
              />
            </transition>
          </div>
        </a>
      </div>
    </b-nav>

    <b-form class="search-wrapper" inline>
      <b-form-group>
        <b-input-group
          v-if="showSearchInputInHeader"
          class="input-group-no-border ml-2"
        >
          <template v-slot:prepend>
            <b-input-group-text
              ><i class="fi flaticon-search-2"
            /></b-input-group-text>
          </template>
          <b-form-input
            v-model="searchTerm"
            id="search-input"
            placeholder="Search..."
          />
          <template v-slot:append>
            <b-input-group-text v-if="searchTerm" @click="resetSearch">
              <i class="fa fa-times"></i>
            </b-input-group-text>
          </template>
        </b-input-group>
        <span @click="safeGoBack" v-else>
          <i role="button" class="fa flaticon-chevron-back" />
        </span>
      </b-form-group>
    </b-form>
  </b-navbar>
</template>

<script>
  import _ from "lodash";
  import { mapState, mapActions } from "vuex";

  export default {
    name: "Header",
    data() {
      return {
        search: this.$route.query.search,
      };
    },
    computed: {
      ...mapState("layout", [
        "sidebarCollapsed",
        "showSidebar",
        "showSearchInputInHeader",
        "hasFeedsFilters",
      ]),
      isMobile() {
        return window.innerWidth <= 768;
      },
      searchTerm: {
        get() {
          return this.$store.state.layout.searchTerm;
        },
        set(value) {
          this.updateSearchTerm(value);

          if (value) {
            this.$router.push({
              query: {
                ...this.$route.query,
                search: value,
              },
            });
          } else {
            const queryWithoutSearchInput = _.omit(this.$route.query, [
              "search",
            ]);
            this.$router.push({ query: queryWithoutSearchInput });
          }
        },
      },
    },

    created() {
      this.updateSearchTerm(this.$route.query.search);
    },
    methods: {
      toggleCollapse() {
        this.toggleSidebarCollapse();
      },
      ...mapActions("layout", [
        "changeSidebarActive",
        "switchSidebar",
        "toggleSidebarCollapse",
        "updateSearchTerm",
      ]),
      safeGoBack() {
        const allowedDomains = [
          "https://app.redstone.finance/",
          "http://localhost:3000/",
          "https://localhost:3000/",
        ];

        const isAllowedDomain = allowedDomains.some((domain) =>
          document.referrer.startsWith(domain)
        );

        if (isAllowedDomain) {
          window.history.back();
        } else {
          // Determine the appropriate base URL
          const currentHost = window.location.host;
          const baseUrl = currentHost.includes("localhost")
            ? "http://localhost:3000/"
            : "https://app.redstone.finance/";

          window.location.href = baseUrl;
        }
      },
      toggleSidebarMenu() {
        this.toggleSidebar();
      },
      resetSearch() {
        this.updateSearchTerm("");
      },
    },
  };
</script>

<style src="./Header.scss" lang="scss"></style>